import { rungOfOffer, rungLabel } from "./offerRung";

/**
 * One offer, as one line of prompt context: "Business Blueprint — Get a full
 * aligned business blueprint with just one sentence from you."
 *
 * Lifted out of callScripts.js, where it was module-private, when Sites needed
 * the same sentence (2026-09-18). A second copy would be two answers to "what
 * does Brill get told about an offer", and those drift — which is the whole
 * reason `offers` is one table and not one per panel. They DID drift: by
 * 2026-09-24 Outreach held two inline copies, Presentations one and Newsletter
 * one that sent the name and rung only. All five come through here now, so the
 * longer description below reaches every panel an offer is linked on.
 *
 * ONE offer, never the ladder. Her call: "it could indicate you need to link
 * the offer so it doesn't show everything." The page, script or deck says which
 * offer it serves, and that one goes in the prompt. Sending seven would cost
 * more on every message and tell Brill less, because nothing would say which
 * one this page is for.
 *
 * `details` (supabase/0029) is "Tell Brill more": what the offer IS, at the
 * length it takes. Her case, 2026-09-24: the Archetype Assessment is a lead
 * magnet, nothing like her flagship, and its 25-word description — which is
 * also what GHL gets as the product description — could not say enough, so
 * Brill wrote its landing page about the flagship instead.
 * COST: the whole text rides on every message wherever the offer is linked.
 */
export function offerLine(offer) {
  if (!offer) return "none connected";
  const head = `${offer.name || "Untitled offer"}${offer.summary ? ` — ${offer.summary}` : ""}`;
  const more = String(offer.details || "").trim();
  return more ? `${head}\nWhat she says this offer is: ${more}` : head;
}

/**
 * HER WHOLE LADDER, for Ask Brill's coaches (her call, 2026-10-22: "that is
 * the important context to have"). The one exception to "one offer, never the
 * ladder" above: a coach is not writing FOR an offer, it is coaching the
 * business those offers make up — which is exactly the question the whole
 * ladder answers. Each offer still goes through offerLine, so there is one
 * answer to what Brill is told about an offer; the price rides beside it
 * (the table hides price for her demos, Brill needs it to coach sales).
 * Retired offers are left out. Null when there is nothing to say.
 */
export function offerLadderBlock(offers = []) {
  const live = (offers || []).filter((o) => o && o.status !== "retired" && (o.name || o.summary));
  if (!live.length) return null;
  const rungs = ["trust", "core", "continuation", "other", null];
  const lines = rungs.flatMap((r) => live
    .filter((o) => rungOfOffer(o) === r)
    .map((o) => `- ${rungLabel(r, "offer") || "Unsorted"}: ${offerLine(o)}${String(o.pricing || "").trim() ? `\n  Price: ${String(o.pricing).trim()}` : ""}`));
  return `[OFFER_LADDER — read only, do not reference as a conversation]\nHer Offer Ladder in Momentum — what she sells today, by rung (Trust Building brings people in, Core is the main offer, Continuation keeps clients after it). This is newer than anything in her Accelerator foundation about her offer; where they differ, the ladder is current.\n\n${lines.join("\n")}`;
}
